import {useCallback, useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app"
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {useUserApp} from "@hooks";
import {isLoadMoreItems, rawMatcherItems} from "../@signals";
import useRawMatcherItems from "./useItems";


export default function useRawMatcherTarget() {
	const { username } = useUserApp()
	const { handleSubmit, handleMoreProducts } = useRawMatcherItems()
	const { showToast } = useAppToast()

	const selected = useSignal(null)
	const isQA = useSignal(false)
	const isLoadingMapping = useSignal(false)
	const targetIndex = useSignal(0)
	const targetData = rawMatcherItems.value[targetIndex.value] || {}

	useEffect(() => {
		setSelectedSKU(targetData?.AIOptions?.[0]?.skuID ?? null, false)
		if ((targetIndex.value + 1) > rawMatcherItems.value.length)
			handleSubmit()
	}, [targetIndex.value])

	const __showToast = () => showToast.error(
		`SID: ${targetData.siteID} ProductID: ${targetData.productID} Failed!`, {
			position: "top-left"
		})

	const setSelectedSKU = useCallback((newValue, saveByQa=true) => {
		selected.value = newValue
		isQA.value = saveByQa
	}, [])

	const setTargetIndex = useCallback(newValue => {
		targetIndex.value = newValue
		batch(() => isLoadingMapping.value = false)
	}, [JSON.stringify(targetData)])

	const saveMapping = useCallback((notFound=false) => {
		isLoadingMapping.value = true

		const skuID = !notFound ? selected.value : null
		setTargetIndex(targetIndex.value + 1)
		postSubmit(`${BACKEND_APIS.MATCHERS}/raw/mapping-product`, {
			skuID: skuID,
			mappingID: targetData.mappingID,
			siteID: targetData.siteID,
			productID: targetData.productID,
			brandID: targetData.brandID,
			notFound: notFound,
			qa: true
		}).catch(e => {
			console.error('ERROR MAPPING PRODUCT', e)
			__showToast()
		})
	}, [JSON.stringify(targetData), selected.value])

	return {
		targetIndex: targetIndex.value,
		targetData: targetData,
		selectedSKU: selected.value,
		isLoadingMapping: isLoadingMapping.value,

		finishItems: !isLoadMoreItems.value && targetIndex.value >= rawMatcherItems.value.length,
		needMorItems: isLoadMoreItems.value && targetIndex.value >= rawMatcherItems.value.length,

		setSelectedSKU,
		setTargetIndex,
		saveMapping,
		handleMoreProducts
	}
}